import { render, staticRenderFns } from "./DisplayPeriodEdit.vue?vue&type=template&id=5d30a2d8"
import script from "./DisplayPeriodEdit.vue?vue&type=script&lang=js"
export * from "./DisplayPeriodEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports